import { useState } from 'react';

interface IPaginationProps {
  state?: { page: number | null; limit: number | null };
}

const usePagination = (props?: IPaginationProps) => {
  const [page, setPage] = useState<number>(props?.state?.page ? Number(props.state?.page) : 0);
  const [limit, setLimitInternal] = useState<number>(
    props?.state?.limit ? Number(props.state?.limit) : 25
  );

  const setLimit = (limit: number) => {
    setPage(0);
    return setLimitInternal(limit);
  };

  return { page, setPage, limit, setLimit };
};

export default usePagination;
